<article class="card" [attr.data-kind]="feature.id">
  <span class="card__glow" aria-hidden="true"></span>
  <span class="card__border" aria-hidden="true"></span>
  <span
    class="card__ripple"
    [class.is-on]="ripple()"
    (animationend)="ripple.set(false)"
    aria-hidden="true"
  ></span>

  <div class="card__body">
    <span class="card__icon" aria-hidden="true">
      <ng-container [ngSwitch]="feature.id">
        <!-- fingerprint -->
        <svg *ngSwitchCase="'biometric'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
          <path d="M12 4.5a7.5 7.5 0 0 0-7.5 7.5v2" />
          <path d="M19.5 13.5V12A7.5 7.5 0 0 0 15 5.1" />
          <path d="M8.5 12a3.5 3.5 0 0 1 7 0v4.5" />
          <path d="M12 12v5.5" />
          <path d="M15.5 19.2a9 9 0 0 0 .8-2.2" />
          <path d="M8.4 19.4A9 9 0 0 0 9.4 15" />
        </svg>
        <!-- chat -->
        <svg *ngSwitchCase="'chatbot'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.5 12.5a7.5 7.5 0 0 1-7.5 7.5H8l-4 3v-4.4A7.5 7.5 0 0 1 8 4.6h5a7.5 7.5 0 0 1 7.5 7.9z" />
          <path d="M9 12.5h.01M13 12.5h.01M17 12.5h.01" stroke-width="2.4" />
        </svg>
        <!-- chart -->
        <svg *ngSwitchCase="'analytics'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 20V5" /><path d="M4 20h16" />
          <path d="M8 20v-5M12 20v-9M16 20v-4" />
          <path d="m8 11 4-4 3 3 4-5" /><path d="M19 5h2v2" />
        </svg>
        <!-- mic -->
        <svg *ngSwitchCase="'voice'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
          <rect x="9.5" y="3" width="5" height="10" rx="2.5" />
          <path d="M6 11.5a6 6 0 0 0 12 0" /><path d="M12 17.5V21" /><path d="M9 21h6" />
        </svg>
        <!-- workflow -->
        <svg *ngSwitchCase="'workflow'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3.5" y="4" width="7" height="6" rx="1.5" />
          <rect x="13.5" y="4" width="7" height="6" rx="1.5" />
          <rect x="8.5" y="14" width="7" height="6" rx="1.5" />
          <path d="M7 10v2.5h10V10" /><path d="M12 12.5V14" />
        </svg>
        <!-- person -->
        <svg *ngSwitchCase="'personalization'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
          <circle cx="12" cy="9" r="3.5" />
          <path d="M5.5 19.5a6.5 6.5 0 0 1 13 0" />
          <circle cx="12" cy="12" r="9.2" />
        </svg>
        <!-- shield -->
        <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3 5 5.8v5.4c0 4.2 3 7.8 7 8.8 4-1 7-4.6 7-8.8V5.8z" />
          <path d="m9.2 12 2 2 3.6-3.8" />
        </svg>
      </ng-container>
    </span>

    <h3 class="card__title">
      {{ expanded ? feature.title : feature.short }}
    </h3>

    <span class="card__detail" *ngIf="expanded" @detail>
      <span class="card__rule" aria-hidden="true"></span>
      <p class="card__text">{{ feature.description }}</p>
      <span class="card__dots" aria-hidden="true"></span>
    </span>
  </div>

  <figure class="card__art" aria-hidden="true">
    <ng-container [ngSwitch]="feature.id">
      <!-- ============ biometric ============ -->
      <svg *ngSwitchCase="'biometric'" viewBox="0 0 200 230" fill="none">
        <defs>
          <linearGradient id="bioG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#ff4d94" /><stop offset="100%" stop-color="#8b5cf6" />
          </linearGradient>
        </defs>
        <g stroke="url(#bioG)" fill="none" stroke-linecap="round">
          <circle cx="100" cy="96" r="60" stroke-opacity=".22" />
          <circle cx="100" cy="96" r="47" stroke-opacity=".38" stroke-dasharray="6 9" />
          <circle cx="100" cy="96" r="34" stroke-opacity=".6" />
          <path d="M100 74c-9 0-16 7-16 16v14" stroke-width="1.7" />
          <path d="M116 90c0-9-7-16-16-16" stroke-width="1.7" />
          <path d="M92 92a8 8 0 0 1 16 0v18" stroke-width="1.7" />
          <path d="M100 92v20" stroke-width="1.7" />
          <path d="M108 116a22 22 0 0 0 2-8" stroke-width="1.7" />
          <path d="M90 118a22 22 0 0 0 2-10" stroke-width="1.7" />
        </g>
        <g stroke="url(#bioG)" fill="none" stroke-opacity=".55">
          <ellipse cx="100" cy="176" rx="58" ry="16" />
          <ellipse cx="100" cy="170" rx="40" ry="11" stroke-opacity=".4" />
          <ellipse cx="100" cy="164" rx="24" ry="7" stroke-opacity=".3" />
        </g>
        <g fill="none" stroke="#8b5cf6" stroke-opacity=".5">
          <rect x="8" y="60" width="40" height="30" rx="5" />
          <path d="M16 70h12M16 78h20" stroke-opacity=".8" />
          <rect x="6" y="120" width="30" height="26" rx="5" />
          <path d="M13 130h14M13 138h9" stroke-opacity=".8" />
        </g>
        <g fill="none" stroke="#ff4d94" stroke-opacity=".65">
          <rect x="152" y="44" width="36" height="34" rx="8" />
          <circle cx="170" cy="57" r="5" /><path d="M162 70a8 8 0 0 1 16 0" />
          <rect x="156" y="116" width="34" height="30" rx="6" />
          <path d="M166 116v-6a7 7 0 0 1 14 0v6" /><circle cx="173" cy="130" r="3" />
        </g>
      </svg>

      <!-- ============ chatbot ============ -->
      <svg *ngSwitchCase="'chatbot'" viewBox="0 0 420 460" fill="none">
        <defs>
          <linearGradient id="lgPhone" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#1b2440" /><stop offset="100%" stop-color="#0d1426" />
          </linearGradient>
          <linearGradient id="lgPink" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#ff4d94" /><stop offset="100%" stop-color="#c026d3" />
          </linearGradient>
          <linearGradient id="lgViolet" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#8b5cf6" /><stop offset="100%" stop-color="#6366f1" />
          </linearGradient>
          <linearGradient id="lgBot" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#a5b4fc" /><stop offset="100%" stop-color="#6d5ce0" />
          </linearGradient>
        </defs>

        <g class="art-phone">
          <rect x="96" y="34" width="220" height="400" rx="34" fill="url(#lgPhone)" stroke="rgba(255,255,255,.22)" stroke-width="2" />
          <rect x="106" y="44" width="200" height="380" rx="27" fill="rgba(10,16,32,.9)" stroke="rgba(255,255,255,.08)" />
          <rect x="176" y="52" width="60" height="9" rx="4.5" fill="rgba(255,255,255,.2)" />
          <text x="124" y="80" font-family="Plus Jakarta Sans, sans-serif" font-size="11" fill="rgba(255,255,255,.65)">9:41</text>
          <g fill="rgba(255,255,255,.55)">
            <rect x="258" y="72" width="3" height="7" rx="1.5" />
            <rect x="264" y="69" width="3" height="10" rx="1.5" />
            <rect x="270" y="66" width="3" height="13" rx="1.5" />
            <rect x="280" y="69" width="18" height="9" rx="3" fill="none" stroke="rgba(255,255,255,.45)" />
            <rect x="282" y="71" width="12" height="5" rx="1.5" />
          </g>
          <rect x="166" y="412" width="80" height="4" rx="2" fill="rgba(255,255,255,.35)" />
        </g>

        <g class="art-bot">
          <path d="M210 150v-16" stroke="rgba(165,180,252,.8)" stroke-width="3" stroke-linecap="round" />
          <circle cx="210" cy="128" r="7" fill="#ff4d94" />
          <rect x="150" y="150" width="120" height="98" rx="30" fill="url(#lgBot)" />
          <rect x="160" y="160" width="100" height="72" rx="24" fill="rgba(12,18,38,.82)" />
          <ellipse cx="188" cy="196" rx="9" ry="11" fill="#ff8ac4" />
          <ellipse cx="232" cy="196" rx="9" ry="11" fill="#ff8ac4" />
          <path d="M140 186c-8 0-13 6-13 14s5 14 13 14z" fill="url(#lgBot)" />
          <path d="M280 186c8 0 13 6 13 14s-5 14-13 14z" fill="url(#lgBot)" />
          <rect x="168" y="256" width="84" height="62" rx="22" fill="url(#lgBot)" opacity=".92" />
          <rect x="182" y="272" width="56" height="30" rx="12" fill="rgba(12,18,38,.6)" />
          <path d="M196 287h28" stroke="rgba(165,180,252,.8)" stroke-width="3" stroke-linecap="round" />
        </g>

        <g class="art-bubble art-bubble--1">
          <rect x="46" y="128" width="96" height="46" rx="18" fill="url(#lgViolet)" />
          <g fill="rgba(255,255,255,.92)">
            <circle cx="74" cy="151" r="5" /><circle cx="94" cy="151" r="5" /><circle cx="114" cy="151" r="5" />
          </g>
        </g>
        <g class="art-bubble art-bubble--2">
          <rect x="248" y="112" width="140" height="52" rx="18" fill="rgba(139,92,246,.5)" stroke="rgba(255,255,255,.14)" />
          <g stroke="rgba(255,255,255,.75)" stroke-width="4" stroke-linecap="round">
            <path d="M270 132h96M270 146h64" />
          </g>
        </g>
        <g class="art-bubble art-bubble--3">
          <rect x="36" y="286" width="132" height="52" rx="18" fill="rgba(99,102,241,.42)" stroke="rgba(255,255,255,.12)" />
          <g stroke="rgba(255,255,255,.7)" stroke-width="4" stroke-linecap="round">
            <path d="M56 306h88M56 320h56" />
          </g>
        </g>
        <g class="art-bubble art-bubble--4">
          <rect x="180" y="356" width="160" height="56" rx="20" fill="url(#lgPink)" />
          <g stroke="rgba(255,255,255,.9)" stroke-width="4" stroke-linecap="round">
            <path d="M202 378h108M202 393h72" />
          </g>
        </g>

        <g class="art-badge">
          <rect x="300" y="196" width="86" height="76" rx="20" fill="rgba(139,92,246,.28)" stroke="rgba(165,180,252,.5)" stroke-width="1.5" />
          <text x="343" y="248" text-anchor="middle" font-family="Plus Jakarta Sans, sans-serif" font-size="38" font-weight="800" fill="#c4b5fd">AI</text>
        </g>
      </svg>

      <!-- ============ analytics ============ -->
      <svg *ngSwitchCase="'analytics'" viewBox="0 0 200 230" fill="none">
        <defs>
          <linearGradient id="anaG" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0%" stop-color="#8b5cf6" /><stop offset="100%" stop-color="#ff4d94" />
          </linearGradient>
        </defs>
        <g fill="url(#anaG)" opacity=".85">
          <rect x="24" y="86" width="17" height="42" rx="4" opacity=".5" />
          <rect x="49" y="70" width="17" height="58" rx="4" opacity=".62" />
          <rect x="74" y="80" width="17" height="48" rx="4" opacity=".55" />
          <rect x="99" y="50" width="17" height="78" rx="4" opacity=".78" />
          <rect x="124" y="34" width="17" height="94" rx="4" opacity=".9" />
          <rect x="149" y="18" width="17" height="110" rx="4" />
        </g>
        <path d="M32 76 57 58 82 66 107 40 132 26 157 12" stroke="url(#anaG)" stroke-width="2" fill="none" stroke-linecap="round" />
        <g fill="#ff4d94">
          <circle cx="32" cy="76" r="3.4" /><circle cx="57" cy="58" r="3.4" />
          <circle cx="82" cy="66" r="3.4" /><circle cx="107" cy="40" r="3.4" />
          <circle cx="132" cy="26" r="3.4" /><circle cx="157" cy="12" r="3.4" />
        </g>
        <g fill="none" stroke="rgba(255,255,255,.18)">
          <rect x="14" y="144" width="172" height="76" rx="10" />
          <path d="M14 166h172" stroke-opacity=".6" />
        </g>
        <circle cx="46" cy="192" r="20" fill="none" stroke="#8b5cf6" stroke-width="7" stroke-opacity=".55" />
        <path d="M46 172a20 20 0 0 1 17 30" fill="none" stroke="#ff4d94" stroke-width="7" />
        <g stroke="rgba(226,232,245,.5)" stroke-linecap="round">
          <path d="M84 182h84M84 194h64M84 206h74" />
        </g>
        <g fill="none" stroke="#3b82f6" stroke-opacity=".7">
          <rect x="150" y="176" width="30" height="30" rx="5" />
          <path d="M158 196v-8M166 196v-13M174 196v-5" stroke-linecap="round" />
        </g>
      </svg>

      <!-- ============ voice & image ============ -->
      <svg *ngSwitchCase="'voice'" viewBox="0 0 200 230" fill="none">
        <defs>
          <linearGradient id="voiG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#8b5cf6" /><stop offset="100%" stop-color="#3b82f6" />
          </linearGradient>
        </defs>
        <rect x="42" y="10" width="116" height="200" rx="18" fill="rgba(255,255,255,.03)" stroke="rgba(255,255,255,.16)" />
        <rect x="86" y="18" width="28" height="5" rx="2.5" fill="rgba(255,255,255,.2)" />
        <g stroke="url(#voiG)" stroke-width="3" stroke-linecap="round">
          <path d="M60 62v14M70 54v30M80 44v50M90 58v22M100 38v62M110 56v26M120 46v46M130 60v18M140 66v6" />
        </g>
        <rect x="56" y="112" width="88" height="26" rx="13" fill="rgba(255,255,255,.05)" stroke="rgba(255,255,255,.2)" />
        <g stroke="rgba(226,232,245,.65)" stroke-linecap="round" fill="none">
          <path d="M70 118v6M67 124a5 5 0 0 0 6 0" />
          <circle cx="128" cy="123" r="5.5" /><path d="m132 127 4 4" />
        </g>
        <rect x="50" y="150" width="56" height="46" rx="8" fill="rgba(59,130,246,.16)" stroke="#3b82f6" stroke-opacity=".55" />
        <path d="M56 186l14-14 10 9 9-11 11 16" stroke="#3b82f6" fill="none" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="68" cy="163" r="4" fill="#8b5cf6" />
        <circle cx="136" cy="176" r="24" fill="url(#voiG)" opacity=".22" />
        <circle cx="136" cy="176" r="18" fill="url(#voiG)" />
        <g stroke="#fff" stroke-width="1.6" fill="none" stroke-linecap="round">
          <rect x="132.5" y="167" width="7" height="12" rx="3.5" />
          <path d="M128 177a8 8 0 0 0 16 0" /><path d="M136 185v3" />
        </g>
      </svg>

      <!-- ============ workflow ============ -->
      <svg *ngSwitchCase="'workflow'" viewBox="0 0 200 230" fill="none">
        <defs>
          <linearGradient id="wfG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#ff4d94" /><stop offset="100%" stop-color="#8b5cf6" />
          </linearGradient>
        </defs>
        <g stroke="rgba(139,92,246,.45)" fill="none" stroke-linecap="round">
          <path d="M100 92V52M100 92H52M100 92h48M100 138v34M100 138H56M100 138h44" />
          <path d="M52 92V64M148 92V64M56 138v30M144 138v26" />
        </g>
        <rect x="66" y="90" width="68" height="52" rx="10" fill="rgba(139,92,246,.16)" stroke="url(#wfG)" stroke-width="1.6" />
        <text x="100" y="123" text-anchor="middle" font-family="Plus Jakarta Sans, sans-serif" font-size="24" font-weight="800" fill="url(#wfG)">AI</text>
        <g stroke="url(#wfG)" fill="none" stroke-opacity=".8">
          <path d="M74 90V80M88 90V80M112 90V80M126 90V80M74 142v10M88 142v10M112 142v10M126 142v10" />
          <path d="M66 104H56M66 118H56M134 104h10M134 118h10" />
        </g>
        <g fill="none" stroke="#ff4d94" stroke-opacity=".7">
          <rect x="24" y="30" width="34" height="34" rx="8" />
          <path d="M32 42h18M32 50h12" stroke-linecap="round" />
        </g>
        <g fill="none" stroke="#8b5cf6" stroke-opacity=".8">
          <rect x="140" y="30" width="34" height="34" rx="8" />
          <path d="m148 47 5 5 9-10" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <g fill="none" stroke="#ff4d94" stroke-opacity=".7">
          <circle cx="42" cy="184" r="17" />
          <circle cx="42" cy="179" r="5" /><path d="M34 191a9 9 0 0 1 16 0" stroke-linecap="round" />
        </g>
        <g fill="none" stroke="#8b5cf6" stroke-opacity=".8">
          <circle cx="152" cy="180" r="17" />
          <circle cx="152" cy="180" r="6" />
          <path d="M152 163v6M152 191v6M135 180h6M163 180h6M140 168l4 4M160 188l4 4M164 168l-4 4M144 188l-4 4" stroke-linecap="round" />
        </g>
      </svg>

      <!-- ============ personalization ============ -->
      <svg *ngSwitchCase="'personalization'" viewBox="0 0 200 230" fill="none">
        <defs>
          <linearGradient id="perG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#8b5cf6" /><stop offset="100%" stop-color="#ff4d94" />
          </linearGradient>
        </defs>
        <rect x="16" y="24" width="120" height="86" rx="12" fill="rgba(255,255,255,.03)" stroke="rgba(255,255,255,.14)" />
        <circle cx="48" cy="56" r="16" fill="rgba(139,92,246,.2)" stroke="url(#perG)" stroke-width="1.6" />
        <circle cx="48" cy="51" r="5.5" fill="url(#perG)" />
        <path d="M38 66a10 10 0 0 1 20 0" fill="url(#perG)" />
        <g stroke="rgba(226,232,245,.45)" stroke-linecap="round">
          <path d="M76 48h44M76 60h30M76 88h44M32 88h30" />
        </g>
        <g fill="none" stroke="url(#perG)" stroke-width="1.6">
          <rect x="140" y="52" width="46" height="50" rx="10" />
          <path d="M152 52v-8a10 10 0 0 1 20 0v8" stroke-linecap="round" />
          <circle cx="162" cy="76" r="4" />
        </g>
        <rect x="16" y="128" width="120" height="34" rx="8" fill="rgba(255,255,255,.03)" stroke="rgba(255,255,255,.12)" />
        <g fill="#ff4d94">
          <path d="m34 138 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z" />
          <path d="m58 138 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z" />
          <path d="m82 138 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z" />
          <path d="m106 138 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z" opacity=".55" />
        </g>
        <g fill="none" stroke="rgba(255,255,255,.14)">
          <rect x="16" y="176" width="76" height="42" rx="8" />
          <rect x="104" y="176" width="80" height="42" rx="8" />
        </g>
        <g stroke="rgba(226,232,245,.4)" stroke-linecap="round">
          <path d="M28 192h40M28 204h26M116 192h50M116 204h34" />
        </g>
        <circle cx="168" cy="146" r="14" fill="none" stroke="#8b5cf6" stroke-opacity=".7" />
        <path d="m162 146 4 4 8-8" stroke="#8b5cf6" fill="none" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <!-- ============ fraud ============ -->
      <svg *ngSwitchDefault viewBox="0 0 200 230" fill="none">
        <defs>
          <linearGradient id="frdG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#ff4d94" /><stop offset="100%" stop-color="#c026d3" />
          </linearGradient>
        </defs>
        <g stroke="rgba(139,92,246,.32)" fill="none" stroke-linecap="round">
          <path d="M14 40h30v22M186 40h-30v22M14 150h26v-24M186 150h-26v-24" />
          <path d="M44 62h18M138 62h18M40 126h16M144 126h16" />
        </g>
        <g fill="rgba(139,92,246,.6)">
          <circle cx="14" cy="40" r="3" /><circle cx="186" cy="40" r="3" />
          <circle cx="14" cy="150" r="3" /><circle cx="186" cy="150" r="3" />
        </g>
        <path d="M100 22 44 44v46c0 36 24 63 56 72 32-9 56-36 56-72V44z" fill="rgba(255,77,148,.14)" stroke="url(#frdG)" stroke-width="2" />
        <path d="M100 34 56 51v39c0 30 20 53 44 61 24-8 44-31 44-61V51z" fill="none" stroke="url(#frdG)" stroke-opacity=".45" />
        <path d="m82 92 13 14 26-28" stroke="url(#frdG)" stroke-width="6" fill="none" stroke-linecap="round" stroke-linejoin="round" />
        <g fill="none" stroke="rgba(255,255,255,.16)">
          <rect x="14" y="180" width="72" height="40" rx="8" />
        </g>
        <g stroke="rgba(226,232,245,.4)" stroke-linecap="round">
          <path d="M26 194h34M26 206h22" />
        </g>
        <path d="M146 178l24 42h-48z" fill="rgba(255,77,148,.16)" stroke="#ff4d94" stroke-width="2" stroke-linejoin="round" />
        <path d="M146 192v12M146 210v.5" stroke="#ff4d94" stroke-width="2.4" stroke-linecap="round" />
      </svg>
    </ng-container>
  </figure>
</article>
